import UIButton from "@mui/material/Button";
import { useFormContext } from "react-hook-form";

import { Button as LocalButton } from "$components";
import { useStyles } from "../styles/ProfileEDB.styles";
import MaterialNeed from "../../form/steps/MaterialNeed";
import { useProfileEDBContext } from "$containers/EDB/ProfileEDB/context/ProfileEDBContext";

export default function AddingMaterial() {
  const classes = useStyles();
  const { watch, getValues } = useFormContext();

  const {
    edb,
    showCart,
    isAddingMaterial,
    displayDeliveryModality,
    isLoadingIntegratedOrders,

    saveEDB,
    setShowCart,
    setIsAddingMaterial,
    setOpenCartModalValidate,
    setOpenModalCreateNewEdb,
    setDisplayDeliveryModality,
  } = useProfileEDBContext();

  // next button
  const handleNextClick = () => {
    if (showCart) {
      setOpenCartModalValidate(true);
    } else if (displayDeliveryModality) {
      const data = getValues();
      delete data._id;
      saveEDB(data);
      setShowCart(false);
      setIsAddingMaterial(false);
      setOpenModalCreateNewEdb(false);
      setDisplayDeliveryModality(false);
    } else {
      setShowCart(true);
    }
  };

  // previous button
  const handlePreviousClick = () => {
    if (showCart) setShowCart(false);
    else setIsAddingMaterial(false);
  };

  return (
    <>
      <MaterialNeed
        companyId={edb?.company._id}
        showCart={showCart}
        setShowCart={setShowCart}
        displayDeliveryModality={displayDeliveryModality}
        isAddingMaterial={isAddingMaterial}
        setIsAddingMaterial={setIsAddingMaterial}
        isLoading={isLoadingIntegratedOrders}
      />
      <div className={classes.navigationStep}>
        <div>
          <UIButton
            variant="outlined"
            style={{ textTransform: "none" }}
            onClick={handlePreviousClick}
          >
            Précédent
          </UIButton>
        </div>
        <div>
          <LocalButton
            disabled={
              watch("products").length === 0 &&
              watch("integratedOrders.orderProducts").length === 0
            }
            onClick={handleNextClick}
          >
            {showCart && !displayDeliveryModality
              ? "Valider le panier"
              : "Continuer"}
          </LocalButton>
        </div>
      </div>
    </>
  );
}
